// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"3c4d68c3","702":"fdc77c7e"}[chunkId] + ".chunk.css";
};